import SessionPublicationcheck from '../../components/session-publicationcheck';
<template><SessionPublicationcheck @session={{@model}} /></template>
